import type { SVGProps } from 'react';

const SvgComment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M6 21.005a1 1 0 0 1-1-1v-3.98c-1.29-1.42-2-3.19-2-5.02 0-4.41 4.04-8 9-8s9 3.59 9 8-4.04 8-9 8c-.49 0-.99-.04-1.47-.11l-4.08 2c-.14.07-.29.1-.44.1zm6-16c-3.86 0-7 2.69-7 6 0 1.43.61 2.82 1.71 3.91.19.19.29.44.29.71v2.78l2.93-1.44c.19-.09.41-.12.62-.09.48.09.97.13 1.45.13 3.86 0 7-2.69 7-6s-3.14-6-7-6"
    />
  </svg>
);
export default SvgComment;
